import axios from 'axios';

const log = require("loglevel").getLogger("fundService");
log.setLevel("error");

export const loadFundById = id => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/funds/get/id`, {id})
		.then(async response => {
			const res = response.data.data;
			log.debug("fundService -> loadFundById -> return");
			return res;
		})
		.catch(response => {
			log.debug("fundService -> loadFundById -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadFunds = (selectedFilters, forceReload) => {
	console.log(selectedFilters);

	return axios.post(`${process.env.REACT_APP_HOST_URL}/funds/get`, {selectedFilters, forceReload: forceReload === true})
		.then(async response => {
			const res = response.data;
			log.debug("fundService -> loadFunds -> return");
			return res;
		})
		.catch(response => {
			log.debug("fundService -> loadFunds -> error: ");
			log.debug(response);
			return null;
		});
};
